import * as React from 'react';

import SVGDynamicIcon from 'components/svg-dynamic-icon/SVGDynamicIcon';

import { __t, applyTranslations } from 'utils/language';

import './deliverable-custom-gallery-thumbnail-overlay.scss';

applyTranslations(require('../deliverable-custom.i18n.json'));

const MSG_KEY = 'deliverable_custom';

const DeliverableCustomGalleryThumbnailOverlay = (
  selectedItem,
  items
): React.ReactNode => {
  const currentItem = items.find(item => selectedItem.id === item.id);

  if (!currentItem.isSelected) {
    return null;
  }

  const mediaType = currentItem.assetType || currentItem.mediaType;

  return (
    <div
      className="deliverable-custom-gallery-thumbnail-overlay"
      title={__t(`${MSG_KEY}.gallery_modal.item_selected`, {
        mediaType: __t(`${MSG_KEY}.gallery_modal.${mediaType}`)
      })}
    >
      <SVGDynamicIcon
        name="checkmark-inside-circle-white-bg-custom-fg"
        width={24}
        height={24}
        customColor="primary"
      />
    </div>
  );
};

export default DeliverableCustomGalleryThumbnailOverlay;
